<template>
  <div>
    <section class="section">
      <div class="itemFixed-nav">
        <div class="itemFixed-nav-content">
          <el-upload
            :action="imageUrl"
            :headers="headers"
            list-type="picture-card"
            class="avatar-uploader"
            name="uploadFile"
            :data="{
              asImage: true,
              fieldName: 'headImageUrl',
              model: uplaodModel,
            }"
            :on-success="
              (res, file) => {
                imageListHandleAvatarSuccess(res, file);
              }
            "
            :on-remove="
              (res, file) => {
                imageListHandleRemove(res, file);
              }
            "
            multiple
            :limit="100"
            :file-list="imageList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </div>
    </section>
  </div>
</template>
  <script>
import { getToken } from "@/utils";
import projectConfig from "@/core/config";
export default {
  props: {
    // 上传模块
    uplaodModel: {
      type: Object,
      default: "",
    },
    // imageList: {
    //   type: Array,
    //   required: false,
    //   default() {
    //     return [];
    //   },
    // },
  },
  data() {
    return {
      imageList: [],
      url: projectConfig.imageBaseUrl, //后台路径
      imageUrl:
        projectConfig.baseUrl + "qingguang/tenantbussiness/common/upload", //上传图片路径
      headers: { Authorization: getToken() },
    };
  },
  created() {},
  methods: {
    //清空图片
    getList() {
      this.imageList = [];
    },
    // 新增多图片
    imageListHandleAvatarSuccess(res, file) {
      let json = {
        name: file.name,
        url: res.data.uploadPath + res.data.filename,
      };
      this.$emit("imageListHandleAvatarSuccess", json);
    },
    imageListHandleRemove(res, file) {
      let list = [];
      file.forEach((item) => {
        if (item.response) {
          list.push({
            name: item.name,
            url: item.response.data.uploadPath + item.response.data.filename,
          });
        } else {
          list.push({
            name: item.name,
            url: item.url.replace(this.url, ""),
          });
        }
      });
      this.$emit("imageListHandleRemove", list, res, file);
    },
  },
};
</script>
<style  scoped>
.section ::v-deep .el-upload--picture-card {
  padding-top: 3px;
}
.section ::v-deep .el-upload-list__item-preview {
  display: none !important;
}
.section ::v-deep .el-upload-list--picture-card .el-upload-list__item-actions {
  font-size: 14px;
}
.section ::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 38px;
  height: 38px;
}
.section ::v-deep .el-upload--picture-card {
  width: 38px;
  height: 38px;
  line-height: 38px;
  vertical-align: middle;
}
/* 那啥，没用的，删了出问题不负责 */
.section {
  height: 50px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -moz-user-select: none; /* Firefox私有属性 */
  -webkit-user-select: none; /* WebKit内核私有属性 */
  -ms-user-select: none; /* IE私有属性(IE10及以后) */
  -khtml-user-select: none; /* KHTML内核私有属性 */
  -o-user-select: none; /* Opera私有属性 */
  user-select: none; /* CSS3属性 */
}
.itemFixed-nav {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.itemFixed-nav-content {
  display: flex;
}
</style>